module.exports = __webpack_public_path__ + "static/media/WEXPOLY-BTC.7982ebac.png";